import { Link } from "react-router-dom";
import { Hammer, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "../components/common";
import { IMAGES } from "../data/site";
import Seo from "../components/Seo";

export default function NosLocations() {
  return (
    <div data-testid="locations-construction-page">
      <Seo
        title="Nos locations – Bientôt disponible | Cleanova-Sud"
        description="Notre sélection de locations saisonnières à Béziers et sur le littoral arrive bientôt. Contactez Cleanova-Sud pour toute demande."
        path="/nos-locations"
        noindex
      />
      <section className="relative" style={{ minHeight: "100vh" }}>
        <img src={IMAGES.luxLiving} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div
          className="relative container-x flex flex-col justify-center"
          style={{ minHeight: "100vh", paddingTop: "8rem", paddingBottom: "4rem" }}
        >
          <Reveal>
            <div
              className="flex items-center justify-center mb-8"
              style={{ width: 64, height: 64, background: "rgba(189,155,84,0.18)", color: "var(--gold-2)", border: "1px solid rgba(189,155,84,0.4)" }}
            >
              <Hammer size={28} />
            </div>
          </Reveal>
          <Reveal delay={60}>
            <Eyebrow light>Nos locations</Eyebrow>
          </Reveal>
          <Reveal delay={120}>
            <h1 className="display-title text-white mt-5 text-5xl md:text-7xl max-w-4xl" data-testid="construction-title">
              Page en <em style={{ color: "var(--gold-2)" }}>construction</em>
            </h1>
          </Reveal>
          <Reveal delay={200}>
            <p className="mt-6 text-lg md:text-xl max-w-2xl" style={{ color: "rgba(255,255,255,0.82)" }}>
              Notre sélection de locations saisonnières à Béziers et sur le littoral arrive très
              bientôt. En attendant, contactez-nous pour toute demande de séjour.
            </p>
          </Reveal>
          <Reveal delay={280}>
            <div className="mt-10">
              <Link to="/contact" className="btn btn-primary" data-testid="construction-contact-btn">
                Nous contacter <ArrowRight size={18} />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
